import { render, staticRenderFns } from "./TaxReference.vue?vue&type=template&id=2f7ab0e9"
import script from "./TaxReference.vue?vue&type=script&lang=js"
export * from "./TaxReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports